var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import Link from '../../atoms/Link';
import { colors, fontSizes, fontWeights, lineHeights } from '../../../defaultTheme';
export const Chevron = styled.span `
  ::before {
    color: ${({ theme }) => theme.icon};
    border-style: solid;
    border-width: 2px 2px 0 0;
    content: '';
    display: inline-block;
    height: 5px;
    left: 10px;
    position: relative;
    vertical-align: top;
    width: 5px;
    top: 6px;
    transform: rotate(135deg);
  }
`;
const NavigationTabStyles = ({ showActiveStyles, theme }) => {
    return `
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px 32px;
    position: relative;
    cursor: pointer;
    
    &:hover {
      text-decoration: none;
    }
    
    ${showActiveStyles
        ? `
          color: ${theme.navigation.activeTabText};
        `
        : `
          color: ${theme.body.text};
          font-weight: ${fontWeights.regular};
          &:visited { color: ${theme.body.text}; }
        `}

    background-color: transparent;
  `;
};
/*
 * Filters out the props that <Link> doesn't take.
 * This removes 'unrecognized prop' errors.
 */
const LinkStyleWrapper = (_a) => {
    var { showActiveStyles, isInline } = _a, props = __rest(_a, ["showActiveStyles", "isInline"]);
    return _jsx(Link, Object.assign({}, props));
};
export const NavigationLink = styled(LinkStyleWrapper) `
  ${(props) => NavigationTabStyles(props)}
`;
export const DropdownButton = styled.button `
  border: none;
  background: inherit;
  font-size: inherit;
  line-height: 1.5;
  font-weight: ${({ showActiveStyles }) => showActiveStyles ? 'bold' : 'normal'};

  ${(props) => NavigationTabStyles(props)}
`;
export const NavigationButton = styled.div `
  background-color: transparent;
  display: inline-block;
  border: none;
  font-size: ${fontSizes.root}px;
  line-height: ${lineHeights.root};
  color: ${({ showActiveStyles, theme }) => showActiveStyles ? `${theme.navigation.activeTabText}` : 'inherit'};
  font-weight: ${({ showActiveStyles }) => showActiveStyles ? 'bold' : 'normal'};
  cursor: pointer;
  padding: 5px 0;
  border-bottom: ${({ showActiveStyles, theme }) => showActiveStyles
    ? `2px solid ${theme.navigation.activeTabBorder}`
    : '2px solid transparent'};

  &:hover {
    border-bottom: ${({ theme }) => `2px solid ${theme.navigation.activeTabBorder}`};
  }
`;
export const NavigationList = styled.ul `
  list-style: none;
  padding-left: 0;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  min-height: 56px;
`;
export const DropdownItem = styled(Link) `
  min-width: 240px;
  padding: 10px;
  justify-content: flex-start;
  font-weight: ${fontWeights.regular};
  color: ${colors.black};

  &:hover {
    text-decoration: none;
    background: ${({ theme }) => theme.hoverBackground};
  }

  &:visited {
    color: ${colors.black};
  }
`;
//# sourceMappingURL=subcomponents.js.map